import axios from 'axios';
import store from '@/store';
import { WHITE_API } from '@/helper/common/constant';

const baseURL: string = process.env.NODE_ENV === 'production' ? '/' : '/api'; //生成
const service = axios.create({
  baseURL,
  timeout: 10000,
  withCredentials: true,
});
service.interceptors.request.use(async (config: any) => {
  config.headers = {
    ...config.headers,
    'Content-Type': 'application/json',
    ReqType: 'APPH5',
  };
  try {
    const common = store.getState().common;
    config.headers['country'] = common.country || 'CN';
    config.headers['timezone'] = common.timezone || 'CTT';
  } catch(e) {
    config.headers['country'] = 'CN';
    config.headers['timezone'] = 'CTT';
  }
  // console.log({config})
  return config;
});

service.interceptors.response.use(
  (response) => {
    const {
      data: { code, data, msg },
      config: { url },
    } = response;
    //白名单内的接口，可直接略过下面的code判断
    if (WHITE_API.has(url || '')) {
      return data;
    }
    console.log(code)
    //成功
    if (code === 200 || code === '2' || code === 'ok') {
      return response.data;
    }
    // 异常
    switch (code) {
      case 40001: // 不需要toast  需要单独在页面中处理逻辑
        return Promise.reject(response.data);
      case '1000': // 不需要toast  需要单独在页面中处理逻辑
        return Promise.reject(response.data);
      case '1001': // 不需要toast  需要单独在页面中处理逻辑
        return Promise.reject(response.data);
      case '1002': // 不需要toast  需要单独在页面中处理逻辑
        return Promise.reject(response.data);
      case '1003': // 不需要toast  需要单独在页面中处理逻辑
        return Promise.reject(response.data);
      default:
        // if(msg!=='活动未开始'){
        //   HdlToast.info(msg);
        // }
        if (response.status == 200) {
          return Promise.reject(response.data)
        }
        return Promise.reject(response);
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);
export default service;
